import React, { useState } from 'react';
import { DialogInput, RequiredDialogSelect, handleInputChange } from '../DialogInputs';
import CommonConfigDialog from './CommonConfigDialog';
import SiteOrBusinessUnitSelect from '../SiteOrBusinessUnitSelect';
import { useSaveConfigurationData, useDeleteConfigurationData } from '../../../../hooks/useConfigurationData';
import { useGetConfigurationDataProperties } from '../../../../hooks/useConfigurationDataProperties';
import { useTranslation } from 'react-i18next';

function ConfigurationDataEditDialog({ dialogData, setDialogData, showDialog, closeDialog }) {
    const { t } = useTranslation();
    const [fieldErrors, setFieldErrors] = useState({});
    const { saveConfigurationData } = useSaveConfigurationData();
    const { deleteFunction } = useDeleteConfigurationData(dialogData);
    const { configurationDataProperties } = useGetConfigurationDataProperties();

    const onChange = (e) => {
        handleInputChange(e, dialogData, setDialogData, fieldErrors, setFieldErrors);
    };

    return (
        <CommonConfigDialog title={"Configuration Data - " + dialogData.name} dialogData={dialogData} showDialog={showDialog} closeDialog={closeDialog} save={saveConfigurationData} canDelete deleteFunction={deleteFunction} fieldErrors={fieldErrors} setFieldErrors={setFieldErrors} >
            <RequiredDialogSelect controlId="formConfigurationDataProperty" title="Property" name="configurationDataPropertyId" value={dialogData.configurationDataPropertyId} error={fieldErrors.configurationDataPropertyId} onChange={onChange}>
                <option value="" key={0} >{t('Application.Controls.DefaultSelect')}</option>
                {configurationDataProperties.map((prop) => <option value={prop.id} key={prop.id}>{prop.name}</option>)}
            </RequiredDialogSelect>
            <SiteOrBusinessUnitSelect controlIdPrefix="Category" dialogData={dialogData} setDialogData={setDialogData} fieldErrors={fieldErrors} />
            <DialogInput controlId="formConfigurationDataValue" title="Value" placeholder="Value" name="value" value={dialogData.value} error={fieldErrors.value} onChange={onChange} />
        </CommonConfigDialog>
    );
}

export default ConfigurationDataEditDialog;